<template>
  <ActBox
    from="babe"
    :postActivityCountries="postActivityCountries"
    :postActivityInfo="postActivityInfoBabe"
    :postActivityRank="postActivityRankBabe" />
</template>
<script>
import { postActivityInfoBabe, postActivityRankBabe } from '@/api/babe'
import { postActivityCountries } from '@/api/user'
import ActBox from '@/components/ActBox.vue'

export default {
  name: 'UserActivity',
  components: {
    ActBox
  },
  data() {
    return {
      postActivityCountries,
      postActivityInfoBabe,
      postActivityRankBabe
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/babe/actdetail.vue